/**
 * Toggle classes
 * @module impressionsControls
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'impressionsControls';

/**
 * Applies any sort of event handlers for the impressionsControls.
 * @param  {jQuery} $el - link
 */
const setEventListeners = ($el) => {
    const activeClass = 'ab-controls--active';
    $el.find('.js-impressions-controls-btn').on('click', () => {
        if ($el.hasClass(activeClass)) {
            $el.removeClass(activeClass);
        } else {
            $el.addClass(activeClass);
        }
    });
    $el.find('.js-impressions-controls-close').on('click', (e) => {
        e.preventDefault();
        $el.removeClass('ab-controls--show');
        localStorage.setItem('impressionsControls', 'false');
    });
    $(document).on('mouseup.dropdown', (e) => {
        if (!$el.is(e.target) && $el.has(e.target).length === 0) {
            $el.removeClass(activeClass);
        }
    });
};

/**
 * Impressions polling
 * @param  {jQuery} $el - link
 */
const doPoll = ($el) => {
    $.get('/dbadmin/spring-controller/impressions/impressions-data', function (data) {
        $el.find('.impressions-widget-data').html(data);
        setEventListeners($el);
        setTimeout(function() {
            doPoll($el);
        }, 3000);
    });
};

/**
 * Initializes impressionsControls.
 * @param {HTMLElement} el - link
 */
export default function impressionsControls(el) {
    const $el = $(el);
    $.ajax({
        url: "/dbadmin/spring-controller/impressions/impressions-widget",
        type: "GET",
        data: { device : 'desktop' },
        success: function(data){
            $el.append(data);
            
            doPoll($el);
            if (localStorage.getItem('impressionsControls') === 'false') {
                $el.removeClass('ab-controls--show');
            } else if (localStorage.getItem('impressionsControls') === 'true' || localStorage.getItem('impressionsControls') === null) {
                $el.addClass('ab-controls--show');
                localStorage.setItem('impressionsControls', 'true');
            }
        }
    });
}
registerJQueryPlugin(PLUGIN_NAME, impressionsControls);


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/impressions-controls.js